<template>
    <div class="container">
    
    <div class="col-xs-12 col-sm-6 col-sm-offset-3">
                <div class="modal-dialog">
                  <div class="modal-content ">
                    <div class="modal-header">
                      <h4> Forgot my password</h4>
                    </div>
                    <div class="modal-body" style="overflow:hidden;">
                      <div class="well" style="overflow: hidden">
                               <br>
     <div class="alert alert-danger" v-if="errorMsg">
        <p>{{ errorMsg }}</p>
      </div>
      <div class="alert alert-info" v-if="alertMsg">
        <p> {{alertMsg}}</p>
      </div>
                              <div class="form-group " v-if="codeSentSuccess==false">
                                  <div class="inner-addon right-addon">
                                  <i v-show="errors.has('email')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('email')" v-if="userData.Email" class="fa fa-paw text-success "></i>
                                  <input @keyup.enter="validateBeforeSubmit()" type="email" name="email" v-validate="'required|email'" :class="{'input': true, 'has-error': errors.has('email') }" class="form-control" v-model.lazy="userData.Email"  placeholder="Email address">
                                  </div>
                                  <span v-show="errors.has('email')" class="help-inline text-danger h5">{{ errors.first('email') }}</span>
                                  
                              </div>
                           

        
        <div v-if="!codeSentSuccess">
        <div v-if="pressed==false"  class="alert alert-info">
          <p >Press Generate code to continue, we will send a 6 digit code and send it to your email</p>
        </div>
            <button class="btn btn-success pull-right" :disabled="count>0" @click="validateBeforeSubmit()">Generate Code {{count}}</button>
        </div>

          
        <div class="form-group"  v-if="codeSentSuccess">
            <div v-if="codeFilled==false" class="col-xs-6 remove-margins">
            <input type="text" class="form-control" placeholder="Verification Code" v-model="userData.Code" maxlength="6" autocorrect="off" autocomplete="off" autocapitalize="off" spellcheck="false"></input> 
            </div>
           
        </div>   
        <div class="form-group" v-if="codeFilled && codeVerifySuccess==false">
            <p class="small"><strong>Code: {{userData.Code}}</strong></p>
            <p class="small"><strong>Enter your new password below</strong></p>
               <div class="form-group">
             <div class="inner-addon right-addon">
                                  <i v-show="errors.has('password')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('password')" v-if="userData.Password" class="fa fa-paw text-success "></i>
                                 <input type="password" name="password" class="form-control" v-validate="'required|min:6'" :class="{'input': true, 'has-error': errors.has('password') }" v-model="userData.Password" @keyup.enter="validatePassword()" placeholder="Password" data-vv-delay="1500">
                                 </div>
                                  <span v-show="errors.has('password')" class="text-danger h5">{{ errors.first('password') }}</span>
                              </div>
            <br>
            <button  v-if="pending" class="btn btn-info pull-right" @click="validatePassword()"> Change Password</button>
            
       <div>
       
       </div>
        </div>
   
        </div>   

        <div >
       
        </div>
            </div >  <!--end of modal well-->
        </div> <!--end of modal body-->
        </div> <!--end of modal content-->
    </div>

       </div>
        </div>
    </div>
    </div>
</template>


<script>
  
  import auth from '../../auth/index'
  import store from '../../data/store'
  
  export default {
    name: 'PasswordReset',
    
    data() {
      return {  
        userData: {
            Email: '',
            Password: '',
            Code: ''

        },
        codeSent: false,
        pressed: false,
        count: '',
        code: '',
        codeSentSuccess: false,
        codeVerifySuccess: false,
        error: '',
        codeFilled:false,
        alert: '',
        pending: true
    }
    },
    methods: {
        validateBeforeSubmit() {
            if (this.errors.has('email') || !this.userData.Email)
            {
                swal("Email required", "Please make sure your email is valid before sending.", "info")
                return
            }
            this.sendCode()
        
    },
    validatePassword() {
            if (this.errors.has('password') || !this.userData.Password)
            {
                swal("Password required", "Please make sure your password is at least 6 characters before sending.", "info")
                return
            }
            this.changePassword()
      },
    startCountDown(){
        var self = this
        self.count=10
        var timer = setInterval(function (){
            self.count--
            if (self.count==0)
            {
                self.count = ''
                clearInterval(timer);
                
            }
        }, 1000)
    },
    redirectLogin(){
        this.$router.push({path: '/login'})
    },
    sendCode(){
          self = this
           self.pressed = true
           self.codeSent = true
           self.startCountDown()

          $.ajax({
            type: 'POST',
            contentType: "application/json",
            url: 'https://www.dupaws.com/services/api/account/SendPasswordCode',
            dataType: "json",
            data: JSON.stringify(self.userData),
            success: function (data) {
                    self.error = ''
                    self.alert = data,
                    self.codeSentSuccess = true
                   
            },
            error:function(error){
            try {
                self.error = error.responseJSON.Message
                    
            } catch(e)
            {
                context.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
        });
      },
      redirectToLogin(){
            this.$router.push({path:"/login" })
      },
      changePassword() {
          self = this
          self.error = ''
          self.userData
        $.ajax({
            type: 'POST',
            contentType: "application/json",
            data: JSON.stringify(self.userData),
            dataType: "json",
            url: 'https://www.dupaws.com/services/api/account/ConfirmPassword',
            success: function (data) {
                self.alert = "Password changed successfully, Sign in with your new password"
                self.pending = false
                self.codeVerifySuccess = true
                swal({
                    title: "Password Reset Success!",
                    text: "Press Login to be directed to login page and use your new credentials",
                    type: "success",
                    showCancelButton: true,
                    confirmButtonClass: 'btn-success',
                    confirmButtonText: "Take me to login",
                    closeOnConfirm: true,
                    html: true
                }, function(){
                    self.redirectLogin()
                });
                
            },
            error:function(){
            try {
                self.error = "Password change failed, check the code is correct and try again"
            } catch(e)
            {
                context.error = "Oops we are having problem logging to the server, please try again in a moment.."
            }
                
            }
        });
      }
    },
    created: function(){
        if (store.getters.email!=null)
            this.userData.Email = store.getters.email
        
    },
    mounted: function() {
            
    },
    watch:{
        'userData.Code': function(){
            if (this.userData.Code.length < 6)
            {
                return false
            }
            else if (this.userData.Code.length==6)
            {
                this.codeFilled = true
            }
        },
    },
    computed: {
        
       
       errorMsg: function(){
           return this.error
       },
       alertMsg: function(){
           return this.alert
       }
    
  }
  }

</script>


<style scoped>
  
</style>


// WEBPACK FOOTER //
// PasswordReset.vue?41f31f90